import { ENV } from "../utils";

export class EnvironmentalRiskMatrixLeopoldform {
  baseApi = ENV.BASE_API;

  async getEnvironmentalRiskMatrixLeopold(accessToken, id) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-leopold/${id}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnvironmentalRiskMatrixLeopold(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-environmentalriskmatrix-leopold`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnvironmentalRiskMatrixLeopold(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-leopold/${id}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnvironmentalRiskMatrixLeopold(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-environmentalriskmatrix-leopold/${id}`;
      const params = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalRiskMatricesLeopoldBySite(accessToken, site) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-leopold-site/${site}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
